import globals from '../../../common/globals';
import CommonService from '../../../common/services/common-service';
import vxAutoSuggest from '../../../search-browse/vx-auto-suggest/vx-auto-suggest.vue';
import vxDropdownPrimary from '../../../common/vx-dropdown-primary/vx-dropdown-primary.vue';
import headerMixin from '../../../common/mixins/header-mixin';
import vxLeftNav from '../../../manage-profile-shopping-lists/vx-left-nav/vx-left-nav.vue';
import mobileMixin from '../../../common/mixins/mobile-mixin';
import vxSpinner from '../../../common/vx-spinner/vx-spinner.vue';
import cookiesMixin from '../../../common/mixins/cookies-mixin';
import { cookies } from '../../../common/mixins/vx-enums';
import vxModal from '../../../common/vx-modal/vx-modal.vue';

import { globalEventBus, cartEventBus } from '../../../../modules/event-bus';

/**
 * Header section
 */
export default {
  name: 'vx-header-section',
  mixins: [headerMixin, mobileMixin, cookiesMixin],
  props: {
    // Header data including categories
    headerData: {
      type: Object,
      required: true,
    },
    // Text and label from properties file
    i18n: {
      type: Object,
      required: true,
    },
    // Flag to enable or disable the favourites option
    isFavoritesEnabled: {
      type: Boolean,
      default: false,
    },
    // Flag to know if the page is home page
    isHomePage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      globals,
      showMobileNav: false,
      selectedPrimary: '',
      cartItems: 0,
      cartId: '',
      screenWidth: screen.width,
      desktopWidthMin: 1200,
      showMiniCart: false,
      userName: '',
      isMiniCartHovered: false,
      miniCartTimeout: 250,
      miniCartTimer: {},
      tabletView: false,
      toggleSearchIcon: false,
      cookies,
      windowWidth: window.innerWidth,
      commonService: new CommonService(),
      isPromoEnabled: false,
      b2bUnitProfilesList: [],
      b2bUnitSelected: {},
      prevSelectedB2bUnit: {},
      presentSelectedB2bUnit: {},
      unitHeaderLogo: '',
    };
  },
  computed: {
    // Configurations for header (includes flags)
    headerOptions() {
      return this.headerData.headerOptions;
    },
    // Login menu data in header data
    loginMenu() {
      return this.headerData.loginMenu;
    },
    // Categories data in header data
    navMenu() {
      return this.headerData.navMenu;
    },
    // Find store/distributor menu data
    findMenu() {
      return this.headerData.findMenu;
    },
    // Checkout header data
    checkoutMenu() {
      return this.headerData.headerOptions.checkoutMenu;
    },
  },
  components: {
    vxAutoSuggest,
    vxLeftNav,
    vxSpinner,
    vxModal,
    vxDropdownPrimary,
  },
  methods: {
    /* global $ */
    /* eslint no-undef: "error" */

    /**
     * Dynamically sets the height for hamburger menu
     */
    setHeaderHeight() {
      if (this.showMobileNav) {
        setTimeout(() => {
          this.$el.querySelector(
            '.header-left-section .mobile-view',
          ).style.height = `${window.innerHeight - 52}px`;
        }, 400);
      }
    },
    /**
     * Closes the hamburger menu
     */
    dismissMobileMenu() {
      if (this.screenWidth <= this.desktopWidthMin) {
        this.showMobileNav = !this.showMobileNav;
      }
    },
    /**
     * Updates the accessibility related attributes
     * @param {boolean} isExpand Indicates if the hamburger is displayed or hidden
     */
    updateAria(isExpand) {
      if (isExpand) {
        if (document.querySelector('.navbar-bottom-right')) {
          document
            .querySelector('.navbar-bottom-right')
            .setAttribute('aria-hidden', true);
        }
        if (document.querySelector('.main__inner-wrapper')) {
          document
            .querySelector('.main__inner-wrapper')
            .setAttribute('aria-hidden', true);
        }
        if (document.querySelector('.footer-section')) {
          document
            .querySelector('.footer-section')
            .setAttribute('aria-hidden', true);
        }
      } else {
        if (document.querySelector('.navbar-bottom-right')) {
          document
            .querySelector('.navbar-bottom-right')
            .setAttribute('aria-hidden', false);
        }
        if (document.querySelector('.main__inner-wrapper')) {
          document
            .querySelector('.main__inner-wrapper')
            .setAttribute('aria-hidden', false);
        }
        if (document.querySelector('.footer-section')) {
          document
            .querySelector('.footer-section')
            .setAttribute('aria-hidden', false);
        }
      }
    },

    /**
     * Displays the secondary category menu and updates the accessibility related attributes for hamburger menu
     * @param {string} selectedItem Primary category item selected by the user
     */
    selectPrimary(selectedItem) {
      this.selectedPrimary = selectedItem;
      const self = this;
      if (this.screenWidth <= this.desktopWidthMin) {
        setTimeout(() => {
          self.$refs.navigationMenu.scrollTop = 0;
          document.querySelector('.js-secondary-action-el').focus();
        }, 150);
      }
      if (this.selectPrimary !== '') {
        if (document.querySelector('.navbar-bottom-right')) {
          document
            .querySelector('.navbar-bottom-right')
            .setAttribute('aria-hidden', true);
        }
        if (document.querySelector('.main__inner-wrapper')) {
          document
            .querySelector('.main__inner-wrapper')
            .setAttribute('aria-hidden', true);
        }
        if (document.querySelector('.footer-section')) {
          document
            .querySelector('.footer-section')
            .setAttribute('aria-hidden', true);
        }
      } else {
        if (document.querySelector('.navbar-bottom-right')) {
          document
            .querySelector('.navbar-bottom-right')
            .setAttribute('aria-hidden', false);
        }
        if (document.querySelector('.main__inner-wrapper')) {
          document
            .querySelector('.main__inner-wrapper')
            .setAttribute('aria-hidden', false);
        }
        if (document.querySelector('.footer-section')) {
          document
            .querySelector('.footer-section')
            .setAttribute('aria-hidden', false);
        }
      }
    },
    /**
     * Checks if secondary categories are available for a primary category and returns boolean
     * @param {string} primaryItem Primary category item selected by the user
     */
    isSecondaryAvailable(primaryItem) {
      return primaryItem.secondaryList && primaryItem.secondaryList.length > 0;
    },
    /**
     * Sets focus to primary category item in hamburger when returning from secondary menu
     * @param {string} el Primary category item
     * @param {object} menu Categories menu
     */
    focusParent(el, menu) {
      this.selectedPrimary = '';
      for (const i in menu) {
        if (menu[i].primary === el) {
          setTimeout(() => {
            document
              .querySelectorAll('.primary-menu-item')
              [i].childNodes[0].focus();
          }, 100);
        }
      }
    },
    /**
     * The below method is used to get the parent
     * element with specific class
     * @param {*the current element} el
     * @param {*the target class } cls
     */
    findAncestor(el, cls) {
      while ((el = el.parentElement) && !el.classList.contains(cls));
      return el;
    },

    returnItemsImages(items) {
      const images = [];
      for (let i = 0; i < items.length; i++) {
        if (items[i].imageData) {
          const imageData = items[i].imageData;
          imageData.link = items[i].ctaLink;
          imageData.isExternalLink = items[i].external;
          images.push(imageData);
        }
      }
      return images;
    },
    /**
     * Handles the window resize
     */
    handleResize() {
      if (window.innerWidth !== this.windowWidth) {
        this.tabletView = this.isTablet();
        this.windowWidth = window.innerWidth;
      }
    },
    /**
     * Sets the height of secondary menu container (only for desktop)
     * @param {object} event Mouseover event
     * @param {number} count Number of secondary menu items for the hovered primary menu item
     */
    setHeaderFlyoutWidth(event, count) {
      /* global $ */
      const targetedElement = event.target;
      const oneColumnWidth = 323;
      const styleProp = $(targetedElement)
        .find('.secondary-menu')
        .attr('style');
      const liList = $(targetedElement).find('.flyout-sec li');
      let liWidth = oneColumnWidth;
      let maxLiWidth = oneColumnWidth;

      if (styleProp) {
        return;
      }
      liList.each(function() {
        const elemwidth = JSON.parse($(this).innerWidth());

        if (liWidth < elemwidth && maxLiWidth < elemwidth) {
          liWidth = elemwidth;
          maxLiWidth = elemwidth;
        }
      });

      if (count > 10 && count < 16) {
        $(targetedElement)
          .find('.secondary-menu')
          .innerWidth(liWidth * 3);
      } else if (count > 15) {
        $(targetedElement)
          .find('.secondary-menu')
          .innerWidth(liWidth * 4);
      } else if (count < 6) {
        $(targetedElement)
          .find('.secondary-menu')
          .innerWidth(liWidth);
        $(targetedElement)
          .find('.js-secondary-child')
          .css('max-width', '100%');
      } else {
        $(targetedElement)
          .find('.secondary-menu')
          .innerWidth(liWidth * 2);
      }
    },
  },
  async mounted() {
    this.clearKauthData();
    this.tabletView = this.isTablet();
    this.isPromoEnabled = !(
      this.globals.siteConfig.isFindAStoreEnabled ||
      this.globals.siteConfig.isFindADistributorEnabled ||
      this.globals.siteConfig.isReferAFriend
    );
    // drop down key board navigation support
    $(document).ready(() => {
      /**
       * used to make the drop down accessible with keyboard for desktop
       */
      if (!this.isTablet()) {
        $('.navigation-inner-wrapper').accessibleDropDown();
      }

      /**
       * desktop keyborad navigation controlling with shift+tab and tab
       */
      $('body').on('keydown', '.navbar-bottom', (e) => {
        const keycode = window.event ? event.keyCode : e.keyCode;
        if (!this.isTablet()) {
          if (e.shiftKey && e.keyCode === 9) {
            // when both shift and tab is pressed
            if (
              document.activeElement.parentElement.className.indexOf(
                'js-primary-menu-item',
              ) > -1
            ) {
              $('.navigation-inner-wrapper')
                .find('.hovered')
                .removeClass('hovered');
              document.activeElement.parentElement.classList.add(
                'js-primary-menu-item',
              );
            }
          } else if (e.keyCode === 9) {
            /** triggers for only tab */
            if (
              document.activeElement.parentElement.className.indexOf(
                'js-secondary-child',
              ) > -1
            ) {
              /** gets the target element node */
              const nodes = Array.prototype.slice.call(
                document.activeElement.parentElement.parentElement.children,
              );
              /** gets the target element parent node */
              const liRef = e.target.parentElement;
              /** checks the condition if the index of target element parent node is equal to the length of the root target element minus 1 */
              if (
                nodes.indexOf(liRef) ===
                document.activeElement.parentElement.parentElement.children
                  .length -
                  1
              ) {
                $('.navigation-inner-wrapper')
                  .find('.hovered')
                  .removeClass('hovered');
                this.findAncestor(
                  e.target,
                  'js-primary-menu-item',
                ).setAttribute('aria-expanded', false);
              }
            }
          }
        } else {
          /** the below block triggers for tablet and mobile */
          /** triggers for the combination of shift and tab */
          if (e.shiftKey && e.keyCode === 9) {
            /** checks if the class is present for the parent element node */
            if (
              e.target.parentElement.className.indexOf('js-primary-menu-item') >
              -1
            ) {
              /** the below logic gets the index of the target element */
              const nodes = Array.prototype.slice.call(
                document.querySelector('.primary-menu').children,
              );
              const liRef = e.target.parentElement;
              /** if the backward tab reaches to first node in primary level the next reverse tab should focus to hamburer icon */
              if (nodes.indexOf(liRef) === 0) {
                setTimeout(() => {
                  document.querySelector('.icon-menu').focus();
                }, 100);
              }
            } else if (
              e.target.className.indexOf('js-secondary-action-el') > -1
            ) {
              /** if the backward tab reaches to first node in secondary level the next reverse tab should focus to back icon */
              setTimeout(() => {
                document
                  .querySelector('.flyout-sec')
                  .lastChild.childNodes[0].focus();
              }, 100);
            }
          } else if (e.keyCode === 9) {
            /** forward tabbed navigation logic for mobile */
            /** checks if the class name is available */
            if (
              e.target.parentElement.className.indexOf('js-primary-menu-item') >
              -1
            ) {
              /** gets the children as an array for the given selector */
              const nodes = Array.prototype.slice.call(
                document.querySelector('.login-mobile-view').children,
              );
              /** gets target parent */
              const liRef = e.target.parentElement;
              if (
                nodes.indexOf(liRef) ===
                document.querySelector('.login-mobile-view').children.length - 1
              ) {
                setTimeout(() => {
                  document.querySelector('.icon-menu').focus();
                }, 100);
              }
            } else if (
              e.target.parentElement.className.indexOf('js-secondary-child') >
              -1
            ) {
              const nodes = Array.prototype.slice.call(
                document.querySelector('.flyout-sec').children,
              );
              const liRef = e.target.parentElement;
              if (
                nodes.indexOf(liRef) ===
                document.querySelector('.flyout-sec').children.length - 1
              ) {
                setTimeout(() => {
                  document.querySelector('.js-secondary-action-el').focus();
                }, 100);
              }
            }
          }
        }
      });
      /**
       * the below block triggers for the tabbed navigation over hamburger icon
       */
      $('body').on('keydown', '.icon-menu', (e) => {
        /**
         * shft + tab naviagtion
         */
        if (e.shiftKey && e.keyCode === 9) {
          /** checks the class presence */
          if (
            document
              .querySelector('.navbar-bottom-left')
              .className.indexOf('mobile-view') > -1
          ) {
            e.preventDefault();
            setTimeout(() => {
              /** sets the focus on the last node */
              document
                .querySelector('.login-mobile-view')
                .lastElementChild.childNodes[0].focus();
            }, 100);
          }
        } else if (e.keyCode === 9) {
          /** tab navigation */
          /** checks the class presence */
          if (
            document
              .querySelector('.navbar-bottom-left')
              .className.indexOf('mobile-view') > -1
          ) {
            e.preventDefault();
            setTimeout(() => {
              /** sets the focus on the first primary link */
              document
                .querySelectorAll('.primary-menu-item')[0]
                .childNodes[0].focus();
            }, 100);
          }
        }
      });
      $(document).on('click', 'body', (e) => {
        if (
          typeof e.target.parentElement.className !== 'object' &&
          !(
            e.target.parentElement.className.indexOf('js-primary-menu-item') >
            -1
          )
        ) {
          $('.navigation-inner-wrapper')
            .find('.hovered')
            .removeClass('hovered')
            .first('a')
            .attr('aria-expanded', false);
        }
      });
    });

    $.fn.accessibleDropDown = function() {
      const el = $(this);
      /* Make dropdown menus keyboard accessible */
      $('a', el).focus(function() {
        $(this)
          .parents('.js-primary-menu-item')
          .addClass('hovered')
          .first('a')
          .attr('aria-expanded', true);
      });
    };

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  filters: {
    maxCharacters(value) {
      const charLimit = 120;
      return value.substring(0, charLimit);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/b2c/common/vx-header-section/vx-header-section.js